export default {
    January: 1, //tháng 1
    February: 2, //tháng 2
    March: 3, //tháng 3
    April: 4, //tháng 4
    May: 5, //tháng 5
    June: 6, //tháng 6
    July: 7, //tháng 7
    August: 8, //tháng 8
    September: 9, //tháng 9
    October: 10, //tháng 10
    November: 11, //tháng 11
    December: 12, //tháng 12

    QuarterI: 1, //Quý I
    QuarterII: 2, //Quý II
    QuarterIII: 3, //Quý III
    QuarterIV: 4, //Quý IV
    ThisWeek : 17, // Tuần này
    LastWeek : 18, // Tuần trước
    ThisMonth: 19, // Tháng này
    LastMonth : 20, // Tháng trước
    ThisQuarter: 21, // Quý này
    LastQuarter : 22, // Quý trước
    ThisYear : 23, // Năm nay
    Month : 24, // Tháng
    Quarter : 25, // Quý
    Year : 26, // Năm
    LastYear: 27, // Năm trước
    SixFirstMonth : 28, // 6 tháng đầu năm
    SixLastMonth : 29, // 6 tháng cuối năm
    Custom : 999, // Tùy chọn
    CustomDeep : 1000 // Tùy chọn tự tạo text để hiển thị
}